<template>
  <div>
    <ul class="file-path-track">
      <li>文档</li>
      <i class="gap-10">/</i>
      <li @click="toRoot" class="path">行业专家访谈</li>
      <li v-if="name" class="path">
        <i class="gap-10">></i>
        <span>{{ name }}</span>
      </li>
    </ul>
    <div class="list">
      <div class="list-header">
        <div>
          <ul v-show="isRoot">
            <span style="font-weight:bold;">多维查看：</span>
            <li class="path" v-for="(item, index) in expertDimension" :key="item.id" :class="{ dimension: dimension !== item.id }" @click="dimension = item.id">
              <span>{{ item.name }}</span>
              <a-divider v-if="index != expertDimension.length - 1" type="vertical"></a-divider>
            </li>
          </ul>
        </div>
        <a-input-search @search="handleSearch" placeholder="搜索文件" v-model="keyword" style="width: 200px;float:right" />
      </div>
      <a-divider style="margin:10px 0"></a-divider>
      <div style="float:right">筛选结果：共{{ searchNum }}个专家访谈</div>

      <div class="table-box">
        <a-table :loading="loading" :columns="columns" :dataSource="list" :rowKey="row => row.id || row.name" :pagination="false" @change="handleTableChange">
          <span 
            class="list-name " data-ga-id="文档-专家访谈-点击文件"
            slot="name" slot-scope="row" @click="handleFolderClick(row)">
            <file-icon :type="row.fileSuffix" v-if="row.fileSuffix" />
            <a-icon type="folder" v-else></a-icon>
            <a-tooltip style="width: 200px;">
              <!-- <template slot="title">{{ row.catalog }}</template> -->
              <span v-if="!row.id" class="gap-l-10">{{ row.name | longText }}</span>
              <a v-else href="javascript:;" @click="handleFileView(row)">{{ row.name | longText }}</a>
            </a-tooltip>
            <span v-if="!row.id" class="text-info">({{ row.fileNum }})</span>
          </span>
          <span class="list-company-name" slot="companyName" slot-scope="row">
            <a href="javascript:;" @click="toProject(row)">{{ row.companyName }}</a>
          </span>
          <div slot="tag" slot-scope="row">
            <div v-if="row.tag" class="selected-container">
              <div class="user-item user-item-hover-delete" v-for="(item, index) in row.tag.split(',')" :key="index" @click="deleteTag(item, row)">
                <span class="tag-over">{{ item }}</span>
                <img class="close" src="/common/close-icon.png" />
              </div>
            </div>
          </div>
          <div slot="action" slot-scope="row">
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>添加标签</span>
              </template>
              <img 
                v-if="row.id" src="/common/tag.png" alt @click="addTag(row)" 
                class="img-size " data-ga-id="文档-专家访谈-点击添加标签"
                style="margin-right:10px" />
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>下载</span>
              </template>
              <img src="/common/download .png" @click="handleFileDownload(row)" alt class="img-size" :class="{ 'row-hidden': !row.canDownload }" />
            </a-tooltip>
          </div>
        </a-table>
      </div>
      <a-pagination
        class="pagination"
        @change="handlePageChange"
        :defaultPageSize="pagination.pageSize"
        v-model="pagination.page"
        :total="pagination.total"
      ></a-pagination>
    </div>
    <a-modal
      title="添加标签"
      :visible="showModel"
      width="400px"
      :footer="null"
      @cancel="
        showModel = false;
        newTag = '';
      "
    >
      <a-input-search v-model="newTag" @search="okModel">
        <a-button slot="enterButton" type="primary">确认</a-button>
      </a-input-search>
    </a-modal>
  </div>
</template>

<script>
import fileIcon from '@/components/base/fileIcon';
import { getExpertFolderList, getExpertFileList, addExpertTag } from '@/api/document';
import { downloadFile as downloadFileApi, getCommonList } from '@/api/common';
import { downloadFile } from 'assets/js/download';
import { mapGetters } from 'vuex';
const columns = [
  {
    title: '名称',
    scopedSlots: { customRender: 'name' },
    key: 'name',
    width: 400,
    sorter: true
  },
  {
    title: '项目',
    scopedSlots: { customRender: 'companyName' },
    width: 150
  },
  {
    title: '上传人',
    dataIndex: 'creatorName',
    key: 'creator',
    width: 150
  },
  {
    title: '大小',
    dataIndex: 'sizeDesc',
    key: 'sizeDesc',
    width: 100
  },
  {
    title: '最近文档上传时间',
    dataIndex: 'createAt',
    key: 'createAt',
    width: 250,
    sorter: true
  },
  {
    title: '标签',
    key: 'tag',
    scopedSlots: { customRender: 'tag' },
    align: 'center',
    width: 150
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
    width: 100
  }
];
export default {
  components: { fileIcon },
  data() {
    return {
      keyword: '',
      loading: false,
      columns,
      list: [],
      searchNum: 0,
      expertDimension: [],
      sorter: {},
      pagination: { page: 1, total: 1, pageSize: 100 },
      dimension: 1,
      name: '', //维度name
      isRoot: true,
      showModel: false,
      newTag: '',
      currentRow: {}
    };
  },
  watch: {
    dimension(val) {
      this.$ga.gaUploadCustomEvent('文档-专家访谈-筛选维度',val);
      this.getfolderList();
    },
    keyword() {
      if (!this.keyword) {
        if (!this.name) {
          this.isRoot = true;
          this.getfolderList();
        } else {
          this.isRoot = false;
          this.getRowFile();
        }
      }
    }
  },
  async mounted() {
    //获取维度列表
    const res = await getCommonList();
    if (res.code === 200) {
      this.expertDimension = res.data.expertDimension;
    }

    if (localStorage.getItem('name')) {
      this.isRoot = false;
      this.name = localStorage.getItem('name');
      this.getRowFile();
      localStorage.setItem('name', '');
    } else {
      this.getfolderList();
    }
    window.onunload = () => {
      localStorage.setItem('name', this.name);
    };
  },
  computed: {
    ...mapGetters(['token'])
  },
  filters: {
    longText(text) {
      return text.length > 40 ? text.substr(0, 40) + '····' : text;
    }
  },
  methods: {
    //点击行业专家访谈
    toRoot() {
      this.isRoot = true;
      this.name = '';
      this.getfolderList();
    },
    //添加新标签
    okModel() {
      if (!this.newTag) {
        this.$message.error('新标签不能为空');
        return;
      }
      let body = {
        type: 1,
        name: this.newTag,
        fileId: this.currentRow.id
      };
      this.handleTag(body);
      this.showModel = false;
      this.newTag = '';
    },
    //删除标签
    deleteTag(item, row) {
      let body = {
        type: 2,
        name: item,
        fileId: row.id
      };
      this.handleTag(body);
    },
    //点击标签
    addTag(row) {
      this.showModel = true;
      this.currentRow = row;
    },
    //操作标签接口
    async handleTag(body) {
      const result = await addExpertTag(body);
      if (result.code === 200) {
        let index = this.list.findIndex(item => +item.id === +body.fileId);
        if (+body.type === 1) {
          if (this.list[index].tag) this.list[index].tag += `,${body.name}`;
          else this.list[index].tag += `${body.name}`;
        } else if (+body.type === 2) {
          let tags = [...this.list[index].tag.split(',')];
          this.list[index].tag = tags.filter(item => item !== body.name).join(',');
        }
        this.$message.success(result.data || 'success');
      }
    },
    //下载
    handleFileDownload(row) {
      downloadFileApi({
        fileType: 'projectFile',
        fileId: row.id
      }).then(res => {
        if (res.code === 200) {
          const downloadPath = res.data + '?Authorization=' + this.token;
          console.log(downloadPath);
          downloadFile(downloadPath);
        }
      });
    },
    handlePageChange(page, pageSize) {
      this.pagination.page = page;
      if (this.isRoot) {
        this.getfolderList();
      } else {
        this.getRowFile();
      }
    },
    // 搜索
    handleSearch(value) {
      if (!value) {
        return;
      }
      this.$ga.gaUploadCustomEvent('文档-专家访谈-搜索名称');
      this.isRoot = false;
      this.keyword = value;
      this.pagination.page = 1;
      this.getRowFile();
    },
    //获取二级文件列表
    async getRowFile() {
      this.loading = true;
      let body = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        dimension: this.dimension,
        name: this.name,
        searchName: this.keyword,
        sortField: this.sorter.sortField,
        isAsc: this.sorter.isAsc
      };
      if (!this.name) {
        delete body.name;
        delete body.dimension;
      }
      if (!this.sorter.isAsc) {
        delete body.isAsc;
        delete body.sortField;
      }
      const result = await getExpertFileList(body);
      let { code, data } = result;
      if (code === 200) {
        this.list = data.list;
        // this.pagination.total = data.total
        this.searchNum = data.total;
        this.loading = false;
      }
    },
    //获取一级文件夹列表
    async getfolderList() {
      this.loading = true;
      let body = {
        dimension: this.dimension,
        sortField: this.sorter.sortField,
        isAsc: this.sorter.isAsc
      };
      if (!this.sorter.sortField) {
        delete body.isAsc;
        delete body.sortField;
      }
      const result = await getExpertFolderList(body);
      let { code, data } = result;
      if (code === 200) {
        this.list = data.list;
        // this.pagination.total = data.num
        this.searchNum = data.num;
        this.loading = false;
      }
    },
    //跳转项目
    toProject(row) {
      window.open(window.location.origin + `/project/detail?id=${row.companyId}`);
    },
    handleTableChange(pagination, filters, sorter) {
      this.sorter.sortField = sorter.columnKey;
      this.sorter.isAsc = sorter.order === 'ascend' ? true : false;
      if (this.isRoot) {
        this.getfolderList();
      } else {
        this.getRowFile();
      }
    },
    //点击文件夹
    handleFolderClick(row) {
      if (!this.isRoot) {
        return;
      }
      this.isRoot = false;
      this.name = row.name;
      this.getRowFile();
    },
    //点击文件
    handleFileView(row) {
      window.open(window.location.origin + `/pdfview?id=${row.id}`);
    }
  }
};
</script>

<style lang="less" scoped>
.file-path-track {
  display: flex;
  li {
    font-size: 14px;
    span {
      cursor: pointer;
    }
  }
}
.list {
  // margin: 0 20px;
  .list-header {
    display: flex;
    justify-content: space-between;
    height: 30px;
    margin-top: 20px;
    ul {
      line-height: 30px;
      display: flex;
    }
    .dimension {
      color: rgb(24, 144, 247);
    }
  }
  .list-name,
  .list-company-name {
    cursor: pointer;
  }
}
.pagination {
  float: right;
  margin: 10px;
}
.path {
  cursor: pointer;
}
.img-size {
  width: 18px;
}
.row-hidden {
  visibility: hidden;
}
.table-box {
  width: 100%;
  overflow-x: scroll;
}
.selected-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  user-select: none;
  min-height: 28px;
  .user-item {
    position: relative;
    padding: 0 4px;
    min-width: 40px;
    height: 20px;
    min-height: 20px;
    margin: 0px 10px 4px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    background: rgb(239, 249, 255);
    border: 1px solid #1892f7;
    border-radius: 5px;
    color: #1892f7;
    font-size: 12px;
    max-width: 120px;
    .tag-over {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .close {
      display: none;
    }
  }
  .user-item-hover-delete {
    .close {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 10px;
      width: 10px;
      transform: translate(-50%, -50%);
      display: none;
    }
    &:hover {
      cursor: pointer;
      border: 1px solid rgb(237, 0, 8);
      color: rgb(205, 205, 205);
      background: rgb(250, 250, 250);
      .close {
        display: block;
      }
    }
  }
}
</style>
